import React, { Fragment, useState, useMemo } from "react";
import I18n from "i18n-js";

import { formatDate } from "../../services/date";

import Table from "./Table";
import Indicator from "./Indicator";
import SelfReportedTeamMetricsDetailsModal from "./SelfReportedTeamMetricsDetailsModal";

const SelfReportedTeamMetricsTable = ({ data, loading }) => {

  const previousResultsDate = formatDate(data.previous_results_date);
  const currentResultsDate = formatDate(data.current_results_date);

  const columns = useMemo(() => [
    {
      id: "title",
      accessorKey: "title",
      header: () => <span>{I18n.t("dashboard.self_reported_team_metrics.title")}</span>,
      cell: info => <span>{I18n.t(`dashboard.self_reported_team_metrics.${info.getValue()}.title`)}</span>,
      sortUndefined: "last",
      sortDescFirst: false
    },
    {
      id: "previous_value",
      accessorKey: "previous_value",
      header: () => <span>{previousResultsDate}</span>,
      cell: info => parseFloat(info.getValue()).toFixed(3),
      sortUndefined: "last",
      sortDescFirst: false
    },
    {
      id: "current_value",
      accessorKey: "current_value",
      header: () => <span>{currentResultsDate}</span>,
      cell: info => (
        <span>
          <Indicator indicator={info.row.original?.indicator} />
          {parseFloat(info.getValue()).toFixed(3)}
        </span>
      ),
      sortUndefined: "last",
      sortDescFirst: false
    }
  ], [previousResultsDate, currentResultsDate]);

  const [selectedKpi, setSelectedKpi] = useState(null);

  const openDetails = (row) => setSelectedKpi(row);

  const handleDetailsClose = () => setSelectedKpi(null)

  return (
    <Fragment>
      <Table
        columns={columns}
        data={data?.kpis}
        loading={loading}
        onRowClick={openDetails}
      />
      <SelfReportedTeamMetricsDetailsModal
        {...selectedKpi}
        onClose={handleDetailsClose}
      />
    </Fragment>
  );
}

export default SelfReportedTeamMetricsTable;
